import { SET_USER_LOGIN, SET_USER_DATA, CLEAR_USER } from "./actionTypes"

export const setUserLogin = (payload) => ({ type: SET_USER_LOGIN, payload })
export const setUserData = (payload) => ({ type: SET_USER_DATA, payload })
export const clearUser = () => ({ type: CLEAR_USER })